import { useEffect, useRef } from 'react'
import PostMessageService, {
  PostMessageType
} from '../../services/communication/post-message.service'

interface ResizerProps {
  idResizer: string
  children?: React.ReactNode
}

// Componente che permette il resizing dell'iframe usato per embeddare l'applicativo in base al suo contenuto.
// in modo da permetterne una visualizzazione integrale e corretta
const Resizer = ({ idResizer, children }: ResizerProps) => {
  // gestione altezza iframe quando embeddato
  const iframeContentRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    // Funzione per inviare l'altezza al genitore
    const sendHeightToParent = (height: number) => {
      PostMessageService.send({
        type: PostMessageType.UPDATE_HEIGHT,
        height: height
      })
    }

    // Osserva i cambiamenti di altezza del contenuto
    const resizeObserver = new ResizeObserver((entries) => {
      if (entries[0].target) {
        const newHeight = entries[0].contentRect.height
        sendHeightToParent(newHeight)
      }
    })

    if (iframeContentRef.current) {
      resizeObserver.observe(iframeContentRef.current)
    }

    // Pulizia al dismount del componente
    return () => {
      if (iframeContentRef.current) {
        resizeObserver.unobserve(iframeContentRef.current)
      }
    }
  }, [iframeContentRef.current])

  return (
    <div id={idResizer + '-resizer'} ref={iframeContentRef}>
      {children}
    </div>
  )
}

export default Resizer
